
/**
 * Append given el to fullscreen ('overlay') and place it back --
 * easier than messing unknown 3rd party styling (or place it back)
 */


(function($) {

    $.fn.toggleFullScreen = function( nameSpaceClass ) {

        var $el = this;

        var NO_OVERFLOW_CLASS = 'noOverflow',
            FULL_SIZE_NO_SPACING_CLASS = 'fullSize-noSpacing';

        if (!$el.data('isOpen')) {

            $('html, body').addClass(
                nameSpaceClass ? nameSpaceClass + ' ' + NO_OVERFLOW_CLASS : NO_OVERFLOW_CLASS
            );

            var $replaceDiv = $('<div id="fsReplaceDiv" style="display: none;"></div> ')
                .insertAfter($el);

            $el.data({
                    origInlineStyle: $el.attr('style'),
                    origClass: $el.attr('class'),
                    isOpen: true,
                    replaceDiv: $replaceDiv
                })
                .removeAttr('style')
                .removeAttr('class')
                .addClass( nameSpaceClass + ' ' + FULL_SIZE_NO_SPACING_CLASS )
                .persistIframeChildrenOnMove()
                .data('$fsWr',
                    $('<div id="fs-wr" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 20000;"></div>')
                        .append($el)
                        .appendTo('body')  //fixed position rel to doc
            );

            //if el not static position & top, left, right, bottom > 0 -- this will be off -- make static
            var origPos =  $el.css('position');
            if (origPos !== 'static') {
                $el.css('position', 'static');
                $el.data('origCSSPosition', origPos); //(flag)
            }


        } else {

            $('html, body').removeClass(
                nameSpaceClass ? nameSpaceClass + ' ' + NO_OVERFLOW_CLASS : NO_OVERFLOW_CLASS
            );

            $el.persistIframeChildrenOnMove() //store prior to append
                .data({ isOpen: false})
                .attr('style', $el.data('origInlineStyle'))
                .addClass($el.data('origClass'))
                .removeClass( FULL_SIZE_NO_SPACING_CLASS )
                .appendTo($el.data('replaceDiv'))
                .unwrap()  //get's rid of the replacement div
                .data('$fsWr')
                .remove();
            //remove after iframes appended to orig div

            /* if original position wasn't static, restore it to the value derived from the class*/
            $el.data('origCSSPosition') && $el.css('position', '');

        }

        return this;

    };

})(jQuery);


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/toggleFullScreen.js
 ** module id = 706
 ** module chunks = 0
 **/